import { AccessTokenStorage, CookieAccessTokenStorage, Handler, PigeonHandler } from '../Api/';
import { Client } from '../ApiClient/';
import { Handler as IApiHandler } from '../ApiClient/Client';
import ErrorHandler from './ErrorHandler';

import type { ErrorLogger } from '../ErrorLogger';
import type { ServiceFactory } from './Application';

const defaultApplicationServiceFactory: ServiceFactory = {
	createAccessTokenStorage: (cookieName: string, options: { domain?: string }) =>
		new CookieAccessTokenStorage(cookieName, options),
	createApiClient: (apiBaseUrl: string, apiHandler: IApiHandler) => new Client(apiBaseUrl, apiHandler),
	createApiHandler: (accessTokenStorage: AccessTokenStorage) => new Handler(accessTokenStorage),
	createErrorHandler: (errorLogger: ErrorLogger) => new ErrorHandler(errorLogger),
	createPigeonClient: (pigeonBaseUrl: string, pigeonApiHandler: IApiHandler) =>
		new Client(pigeonBaseUrl, pigeonApiHandler),
	createPigeonHandler: (accessTokenStorage: AccessTokenStorage, pigeonAuthProvider: string) =>
		new PigeonHandler(accessTokenStorage, pigeonAuthProvider),
};

export default defaultApplicationServiceFactory;
